<template>
    <div class="panel panel-default contract-box"
         v-bind:class="{selected: selected}"
         v-on:click="handleClick(contract)"
         v-if="loaded">
        <a class="panel-heading">
            <div class="desc f -wrap -gutter">
                <div class="expand">
                    <strong>#{{ contract.id }}</strong>
                    <span v-if="contract.number">/ {{ contract.number }}</span>
                    &mdash;
                    {{ companyInfo.company }}
                    {{ companyInfo.type }}
                </div>

                <div v-if="!contract.date_stop">
                    <span v-for="process in ongoingProcesses">
                        <span class="badge">
                            {{ process }}
                        </span>
                    </span>
                </div>
                <div v-if="contract.date_stop">
                    <span class="badge">
                        Résilié
                    </span>
                </div>
            </div>
            <div class="wires">
                {{{ contract.wire_initial|money }}} /
                {{{ contract.wire_monthly|money }}}
            </div>
        </a>
        <ul class="panel-body list-group">
            <exchange-row :ex="ex" v-for="ex of contract.exchanges"></exchange-row>
        </ul>

        <div v-if="contract.pending_ops" class="pending-ops">
            <span class="badge">
                {{ contract.pending_ops }}
            </span>
        </div>
    </div>
</template>

<style scoped lang="less">
    a {
        display: block;
        cursor: pointer;
    }

    .panel {
        position: relative;
    }

    .panel-body {
        padding: 0;
    }

    .pending-ops {
        position: absolute;
        right: 1rem;
        top: 0.5rem;

        .badge {
            cursor: pointer;
            font-size: 80%;
        }
    }
</style>

<script type="text/ecmascript-6">
    import {getAllCompanies} from '../../api/companies';
    import {sleep} from '../../utils';
    import router from '../../router';
    import ExchangeRow from './ExchangeRow';

    export default {
        components: {
            ExchangeRow
        },
        props: {
            contract: {
                required: true,
                twoWay: true
            },
            onClick: {
                type: Function
            },
            selected: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loaded: false,
                companiesDb: undefined
            };
        },
        methods: {
            handleClick(contract) {
                if (typeof this.onClick !== 'function') {
                    router.replace({
                        name: 'contracts-edit',
                        params: {id: contract.client, contractId: contract.id}
                    });
                } else {
                    this.onClick(contract);
                }
            }
        },
        computed: {
            companyInfo() {
                if (!this.companiesDb || !this.contract) {
                    return;
                }

                let companyName, typeName;

                this.companiesDb.some((company) => {
                    if (company.slug === this.contract.company) {
                        company.types.some((type) => {
                            if (type.slug === this.contract.type) {
                                companyName = company.name;
                                typeName = type.name;
                                return true;
                            }
                        });
                        return true;
                    }
                });

                if (companyName && typeName) {
                    return {
                        company: companyName,
                        type: typeName
                    };
                }
            },
            ongoingProcesses() {
                if (!this.contract.processes) {
                    return [];
                }
                return this.contract.processes.filter((x) => !x.done).map((x) => {
                    return x.steps.filter((y) => y.id === x.current_step)[0].name;
                });
            }
        },
        ready: async function () {
            let cont = true;

            while (cont) {
                try {
                    this.companiesDb = await getAllCompanies();
                    cont = false;
                } catch (e) {
                    await sleep(1000);
                }
            }

            this.loaded = true;
        }
    };
</script>



// WEBPACK FOOTER //
// ContractBox.vue?660b4344